import { EmptyCell, type IColumn, Typography } from 'shared/ui'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { getCellForNameDefault } from 'shared/helpers/getCellForNameDefault'
import { uiStore } from 'shared/store/uiStore'
import { type TaggedContactsRow } from 'entities/Tags/model/TaggedContactsRow'

export const columns = (): IColumn<TaggedContactsRow>[] => [
  {
    field: 'full_name',
    name: 'Name',
    maxWidth: '151px',
    isSortable: true,
    renderRowCell: (row) => {
      if (!row.full_name) return <EmptyCell />

      return getCellForNameDefault({
        fullName: row.full_name,
        avatarInfo: row.avatarInfo,
      })
    },
  },
  {
    field: 'formatted_number',
    name: 'Phone',
    isSortable: true,
    maxWidth: '101px',
    renderRowCell: (row) => getLabelAsNumberInternationalFormat(row.number.toString()),
  },
  {
    field: 'email',
    name: 'Email',
    isSortable: true,
    maxWidth: '112px',
    renderRowCell: (row) =>
      row.email ? (
        <Typography
          variant='body-md-regular'
          ariaLabel='TaggedContactEmail'
          tag={'div'}
          ellipsis
          tooltipProps={{
            label: row.email,
          }}
        >
          {row.email}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'created_at',
    name: 'Created at',
    isSortable: true,
    maxWidth: '115px',
    renderRowCell: (row) => {
      const createdAt =
        row.created_at && uiStore.dayjs(row.created_at).format(DayjsFormats.fullWithAtDash2)

      if (!createdAt) return <EmptyCell />

      return (
        <Typography
          variant='body-md-regular'
          ariaLabel='TaggedContactCreatedAt'
          tag={'div'}
          ellipsis
          tooltipProps={{
            label: createdAt,
          }}
        >
          {createdAt}
        </Typography>
      )
    },
  },
]
